/**
 * Information about the current platform. We use this to orchestrate
 * app linking with the Android and iOS apps.
 */

import { detect } from 'detect-browser'

const browser = detect()

export const iOS = 'iOS'
export const ANDROID = 'Android OS'
export const WIN_MOBILE = 'Windows Mobile'
export const UNKNOWN_OS = 'OS not detected'

// iOS native isn't working with detect, returns a null.
// Added support for iPad devices running iOS 13 or higher.
let os = browser === null ? UNKNOWN_OS : ((browser.os === 'Mac OS' && browser.name === 'ios-webview') ? iOS : browser.os)

export const OS = os


// Android and iOS are the only platforms we support, we assume that an unknown OS is mobile
export const IS_MOBILE = [iOS, ANDROID, WIN_MOBILE, UNKNOWN_OS].indexOf(OS) >= 0

export const IS_ANDROID = OS === ANDROID

export const IS_iOS = OS === iOS
export const IS_SAFARI = browser.name == "safari"

// Mobile and web correspond to application types:
// - mobile includes the Android and iOS mobile applications
// - web includes the browser
export const PLATFORM = IS_MOBILE ? 'mobile' : 'web'

// iOS Safari 11 struggles with WebRTC, causing crashes,
// We also haven't nailed down Android support yet.
export const SUPPORTS_VIDEO_CALLS = [ANDROID, iOS, WIN_MOBILE].indexOf(OS) < 0

export const BROWSER_NAME = browser.name
export const BROWSER_VERSION = browser.version
export const OPERATING_SYSTEM = browser.os
